import {Basic} from "./Basic";
import {Browser} from "./Browser";
import {Display} from "./Display";
import {Load} from "./Load";
import {History} from "./History";
import {Slider} from "./Slider";

// set variables
Basic.init();

window.addEventListener('DOMContentLoaded',function()
{
    // get environment
    Browser.analyze();
    Display.analyze();

    // get language from HTML
    Basic.lang = document.documentElement.lang;

    // remove hover class on mobile devices
    if(Browser.mobile === true)
    {
        document.body.classList.remove('no-touch');
    }

    // add event listener
    document.body.addEventListener('click',e =>
    {
        let el = e.target;
        if(el.closest('.iLink'))
        {
            el = el.closest('.iLink');
        }

        if(el.classList.contains('iLink') &&
           Display.device === 'desktop' &&
          !document.body.classList.contains('home') &&
           document.body.dataset.ise !== 'on')
        {
            e.preventDefault();
            const url = el.dataset.url ? el.dataset.url : el.href;
            Load.post({
                f: 'load',
                url: el.href
            }).then(r => {
                History.push_url(el.href);
                Basic.update_page(r, url);
            }).catch(r => {
                console.error(r, url);
            });
        }
        else if(el.classList.contains('w__video'))
        {
            e.preventDefault();
            Basic.build_video(el);
        }
        else if(el.classList.contains('w__video--play'))
        {
            e.preventDefault();
            Basic.build_video(el.closest('.w__video'));
        }
        else if(el.classList.contains('w__toggle-menu'))
        {
            document.getElementById('menu').classList.add('open');
        }
        else if(el.classList.contains('w__button') &&
                el.classList.contains('w__button--smartconfig'))
        {
            const div = el.closest('.w__iframe'),
                  myIframe = document.createElement('iframe');
            myIframe.src = el.dataset.url;
            myIframe.classList.add('w__iframe');
            myIframe.frameborder = 0;
            div.insertAdjacentElement('beforebegin',myIframe);
            div.remove();
        }
    });

    // replace first history element
    History.replace_url();

    // add history event
    History.add_event();

    // initial stuff
    Basic.do_afterLoad();

    new Slider();
});

// window resize detection
window.addEventListener('resize',() =>
{
    cancelAnimationFrame(Basic.resizeTimer);
    Basic.resizeTimer = requestAnimationFrame(Basic.process_resize);
});

// window scroll detection
window.addEventListener('scroll',() =>
{
    cancelAnimationFrame(Basic.scrollTimer);
    Basic.scrollTimer = requestAnimationFrame(Basic.process_scroll);
});